import styled from 'styled-components';

import { Text } from '../../../components';
import { MainButton } from '../auth.styles';

export const VerifySubtitleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-items: flex-start;
  align-items: center;
  margin-top: -1rem;
  margin-bottom: 1.5rem;
`;

export const VerifySubtitleText = styled(Text).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    color: '$textSecondary',
    fontSize: '$sm',
    lineHeight: '$base2',
  },
}))``;

export const VerifySubtitleEmail = styled(Text).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    fontSize: '$sm',
    lineHeight: '$base2',
  },
}))``;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const VerifyButton = styled(MainButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    marginTop: '$md',
  },
}))``;
